import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageCircle, Users } from 'lucide-react';
import { Button } from './ui/button';

const WhatsAppChannelSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Join Our WhatsApp Group",
      description: "Get updates, tips, and special offers!",
      cta: "Join Group",
      members: "5,000+ Members"
    },
    ar: {
      title: "انضم إلى مجموعتنا على واتساب",
      description: "احصل على تحديثات ونصائح وعروض خاصة!",
      cta: "انضم للمجموعة",
      members: "5,000+ عضو"
    }
  };

  const t = content[language];

  return (
    <section className="py-10 bg-gradient-to-r from-green-50 to-teal-50">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Left - Icon & Text */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-7 h-7 text-white fill-white" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">{t.title}</h3>
                <p className="text-sm text-gray-600">{t.description}</p>
              </div>
            </div>
            
            {/* Right - Button */}
            <a
              href="https://chat.whatsapp.com/IHfjVI9WMhVB5EcmgSL0tG?mode=ems_copy_c"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-all whitespace-nowrap">
                <MessageCircle className={`w-5 h-5 ${language === 'ar' ? 'ml-2' : 'mr-2'} fill-white`} />
                {t.cta}
              </Button>
            </a>
          </div>
          
          {/* Members count */}
          <p className="text-center text-sm text-gray-500 mt-3 flex items-center justify-center gap-2">
            <Users className="w-4 h-4" />
            {t.members}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppChannelSection;
